import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CosDataTo } from '../../shared/models/cosDataTo';
import { CallTypeEnum } from '../../shared/enums/callType';
import { LocationTypeEnum } from '../../shared/enums/locationType';
import { SharedService } from '../../shared/shared.service';
import { Alerts } from '../../shared/enums/alerts';

@Component({
    selector: 'app-add-cos',
    templateUrl: './add-cos.component.html',
    styleUrls: ['./add-cos.component.scss']
})
export class AddCosComponent {

    header = 'Add Class of Service Entry';
    loading = false;
    newRow: CosDataTo = new CosDataTo();
    callTypes: string[] = Object.values(CallTypeEnum);
    locationTypes: string[] = Object.values(LocationTypeEnum);
    existingCodes: string[];

    constructor(public dialogRef: MatDialogRef<AddCosComponent>,
                @Inject(MAT_DIALOG_DATA) public data: { existingCodes: string[] },
                private sharedService: SharedService) {
        this.existingCodes = data?.existingCodes || [];
    }

    add() {
        if (!this.newRow.cos || !this.newRow.callType) {
            this.sharedService.showAlert(Alerts.ERROR, 'Please provide a CoS code and call type');
            return;
        }
        if (this.existingCodes.map(c => c.toUpperCase()).includes(this.newRow.cos)) {
            this.sharedService.showAlert(Alerts.ERROR, 'That CoS code already exists in this list');
            return;
        }
        this.dialogRef.close(this.newRow);
    }

    close() {
        this.dialogRef.close(false);
    }
}
